import { AppThunk } from '../../../store/rootReducer';
import { wavesFilteredByPreferences } from '../../waves-tags-display-annotate/utils/user-settings-filter-waves';
import { Wave, WaveProcessor } from '../types/wave.type';

export const processWaves =
  (waves: Wave[] = []): AppThunk<Wave[]> =>
  (_, getState) => {
    const filters: WaveProcessor[] = [wavesFilteredByPreferences];

    let preparedWaves = waves;

    filters.forEach((filter) => {
      preparedWaves = filter(preparedWaves, getState);
    });

    return preparedWaves;
  };
